export default{
    state:{
        theme:"theme1",
        isPlay:false,
    },
    mutations:{
        SET_isPlay(state,val){
            state.isPlay = val
        },
        SET_theme(state,val){
            state.theme = val
        },
    },
    getters: {
        zhuti_values:state =>{
            if (state.theme==='theme1') {
                return true
            }else{
                return false
            }
        },
        themeStatis: state => state.theme,
        header_cell_style_bd: state => {
            if (state.theme==='theme1') {
                return {'background-color':'rgba(17,15,18,1)','color':'white'}
            }else{
                return {'background-color':'#3390F8','color':'white','border-right':'1px solid transparent'}
            }
        },
        cell_style_bd: state => {
            if (state.theme==='theme1') {
                return {'background-color':'rgba(17,15,18,0.9)','color':'white'}
            }else{
                return {'background-color':'white','color':'#707780'}
            }
        },
        satellite_apply_cell_style_bd: state => {
            if (state.theme==='theme1') {
                return {'background-color':'rgba(10, 12, 29, 1)','color':'white'}
            }else{
                return {'background-color':'white','color':'#707780'}
            }
        },
        product_upload_style_bd: state => {
            if (state.theme==='theme1') {
                return {'background-color':'rgba(20, 20, 47, 1)','color':'white'}
            }else{
                return {'background-color':'white','color':'#707780'}
            }
        }
    }
}